interface Image {
  width: number
  height: number
  src?: string
  url?: string
  alt: string
}

export const url = (imageData: Image, crop?: boolean): string => {
  const output = new URL(imageData.src ?? imageData.url, `https://${Shopify.cdnHost}`);

  output.searchParams.append('width', '{width}');
  output.searchParams.append('height', '{height}');
  if (crop) output.searchParams.append('crop', 'center');

  return decodeURI(output.toString());
};

export const image = (imageData: Image, className = '', crop = true, aspect = imageData.width / imageData.height): string => `
  <img
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    data-src="${url(imageData, crop)}"
    data-aspectratio="${aspect}"
    data-sizes="auto"
    data-max-width="${imageData.width}"
    data-max-height="${imageData.height}"
    alt="${imageData.alt ?? ''}"
    class="${className} lazyload"
    decoding="async"
  >
`;

export const source = (imageData: Image, media: string, aspect = imageData.width / imageData.height): string => `
  <source
    data-src="${url(imageData)}"
    data-aspectratio="${aspect}"
    data-max-width="${imageData.width}"
    data-max-height="${imageData.height}"
    media="(min-width: ${media})"
  >
`;

export default {
  image,
  source,
  url,
};
